module.exports = __webpack_public_path__ + "static/media/6.8.0213151b.png";